<template>
  <div class="lnb minimized" style="z-index:7">
    <ul class="menu-depth01">
      <li v-for="(menuhead,i) in data" :key="i">
        <a href="#" style="display:flex;">
          <div style="width: 30px;">
            <i :class="`lnb-icon ${menuhead.icon}`"></i>
          </div>
          <div>{{ menuhead.programNm }}</div>
        </a>
        <ul class="menu-depth02">
          <li v-for="(mainmenu,i) in menuhead.subProgramList" :key="i">
            <router-link :to="{path: mainmenu.url}" class="navbar-item">
              {{ mainmenu.programNm }}</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
        //menu
        data: [],
    };
  },
  async mounted() {
    let res = await this.$menu.get(this.$store.state.loginInfo.loginId);

    this.data = res;

    this.$swiper.resizeMenu();
  },
  methods: {
    removeOn(){
      if ($(".lnb").hasClass("minimized")) {
        $(".lnb .menu-depth01 > li").removeClass("open");
        $(".lnb.minimized .menu-depth01 > li").children().removeClass("on");
        $(".menu-depth02").css("display", "none");
        // el-button el-button--default el-popover__reference
      } else {
        // $(".lnb").addClass("minimized");
        // $(".header > .logo").addClass("mini");
        // $(".header .logo > a > img.logo-big").css("display", "none");
        // $(".header .logo > a > img.logo-mini").css("display", "none");
        
        // $(".lnb .menu-depth01 > li").removeClass("open");
        // $(".lnb.minimized .menu-depth01 > li").children().removeClass("on");
        // $(".menu-depth02").css("display", "none");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
